import { render, staticRenderFns } from "./InfoTestType.vue?vue&type=template&id=8fa578b0&scoped=true"
import script from "./InfoTestType.vue?vue&type=script&lang=js"
export * from "./InfoTestType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa578b0",
  null
  
)

export default component.exports